<template>
  <div class="container-fluid">
    <confirm-dialog></confirm-dialog>
    <div class="row justify-content-center" v-if="showData">
      <div class="col-12 col-lg-6 mb-3">
        <h3>{{ data.head.asunto }}</h3>
      </div>
      <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end">
        <button type="button" class="e-control e-btn e-lib e-success" data-ripple="true"
                v-on:click="onRegulatoryAffairsEdit">
          Editar
        </button>
      </div>
    </div>
    <div class="container mt-2">
      <div class="row justify-content-center" v-if="showData">
        <div class="col-4 col-lg-4 mb-3">
          <h4>{{ $t('textAffairAssociation.textAffairGrid.theme') }}</h4>
          <p>{{ data.head.tema }}</p>
        </div>
        <div class="col-4 col-lg-4 mb-3">
          <h4>{{ $t('textAffairAssociation.textAffairGrid.subtheme') }}</h4>
          <p>{{ data.head.subtema }}</p>
        </div>
        <div class="col-4 col-lg-4 mb-3">
          <h4>{{ $t('textRegulatoryAffairs.textFormKeywords') }}</h4>
          <span v-for="(k, d) in data.head.keywords" class="badge badge-info mr-2">{{ k }}</span>
        </div>
      </div>
    </div>
    <div class="row" v-if="showData">
      <div class="col-12 col-lg-6 mb-3">
        <h4>{{ $t('textRegulatoryAffairs.textTitleCompliance') }}</h4>
      </div>
      <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end">
        <button type="button" class="e-control e-btn e-lib e-success" data-ripple="true"
                v-on:click="onAddCompliance">
          Añadir cumplimiento / Deber
        </button>
      </div>

      <ejs-grid 
          ref='grid' 
          :dataSource='computeDataBody' 
          :allowPaging="true" 
          :allowSorting="true"
          :pageSettings='pageSettings' 
          :toolbar='toolbar' 
          :searchSettings='searchOptions'
      >
        <e-columns>
          <e-column width="40" textAlign="left" field="relevancia" headerText="" :template="templateRelevance"></e-column>
          <e-column textAlign="center" field="titulo" headerText="TITULO" :template="templateTitle"></e-column>
          <e-column field="reporting_authority.name" headerText="AUTORIDAD" textAlign="left"></e-column>
          <e-column width="188" textAlign="center" headerText="PERIODICIDAD" :template="templateListDates"></e-column>
          <e-column headerText="NORMAS" :template="templateListRules"></e-column>
          <e-column width="133" headerText="OPCIONES" :template="templateOptions"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import {Page, Sort, Toolbar, Search} from "@syncfusion/ej2-vue-grids";

export default {
  name: 'detail-affair',
  provide: {
    grid: [Sort, Page, Toolbar, Search]
  },
  data() {
    return {
      id: this.$route.params.id,
      data: {},
      showData: false,
      toolbar: ['Search'],
      pageSettings: {pageSize: 20},
      searchOptions: {ignoreAccent: true},
      templateListRules: function (e) {
        return {
          template: Vue.component('templateListRules', {
            template: `
              <div>
              <ol>
                <li v-for="(d) in data.normas">{{ d.titulo }}</li>
              </ol>
              </div>`
          })
        }
      },
      templateListDates: function (e) {
        return {
          template: Vue.component('templateListDates', {
            template: `
              <div>
                <span style="text-align: center;">{{ data.periodicidad }}</span>
                <div class="">
                  <span v-if="data.periodicidad !== 'Permanente'" v-for="(d) in data.fechas"
                    class="badge badge-secondary m-1">
                      {{ d.fecha_cumplimiento }}
                    </span>
                </div>
              </div>`,
          })
        }
      },
      templateTitle: function (e) {
        return {
          template: Vue.component('templateTitle', {
            template: `
              <div>{{ data.titulo }}</div>`,
          })
        }
      },
      templateRelevance: function (e) {
        return {
          template: Vue.component('templateRelevance', {
            template: `<div>
                <i 
                  class="fa fa-info-circle" 
                  :class="Class(data)" 
                  :title="'Relevancia: ' + relevanciaText"
                >
                </i>
              </div>`,
            methods: {
              Class: function (data) {
                this.relevanciaText = data.relevancia;
                switch (this.relevanciaText) {
                  case 'Baja':
                    return 'text-success';
                  case 'Media':
                    return 'text-warning';
                  case 'Alta':
                    return 'text-danger';
                  default:
                    return 'bg-white border border-dark';
                }
              }
            }
          })
        }
      },
      templateOptions: function (e) {
        return {
          template: Vue.component('templateOptions', {
            template: `<div class="btn-group" role="group">
                <button @click="onComplianceEdit(data)" class="btn btn-sm btn-primary" title="Actualizar"><i class="fa fa-refresh"></i></button>
                <button @click="onComplianceHistory(data)" class="btn btn-sm btn-secondary" title="Historial"><i class="fa fa-clock"></i></button>
                <button v-show="canProfileUse()" @click="onComplianceDelete(data)" class="btn btn-sm btn-danger" title="Eliminar"><i class="fa fa-trash"></i></button>
              </div>`,
            methods: {
              onComplianceDelete: function (data) {
                this.$store.dispatch('moduleCompliance/deleteCompliance', {
                  compliance_id: data.id,
                  process_id: this.$route.params.id,
                });
              },
              onComplianceEdit: function (data) {
                Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Actualizar', 'edit-compliance', data);
              },
              onComplianceHistory: function (data) {
                Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Historial', 'history-compliance', data);
              },
              canProfileUse: function () {
                return ['Estructurador', 'Abogado'].includes(this.$store.getters['moduleAvatar/avatar'].role);
              }
            }
          })
        }
      },
    }
  },
  computed: {
    role(){
      return this.$store.getters['moduleAvatar/avatar'].role
    },
    computeDataBody() {
      return this.data.body.map((item) => {
        return {
          ...item,
          reporting_authority: item.reporting_authority || {name: 'SIN_AUTORIDAD'},
        };
      });
    }
  },
  methods: {
    getAffairDetail: function () {
      axios.post('/auth/regulatoryAffairs/getDetailsAffair', {
        id: this.id
      }).then((response) => {
        this.data = response.data;
        this.showData = true;
      });
    },
    onRegulatoryAffairsEdit: function () {
      Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Editar Asunto Normativo', 'regulatory-affairs-form', this.data.head);
    },
    onAddCompliance: function () {
      Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Añadir Cumplimiento / Deber', 'add-compliance', this.data.head);
    }
  },
  created() {
    this.getAffairDetail();
    this.$eventHub.$on('onGetCompliance', this.getAffairDetail);
  }
}
</script>
